<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="label"
        :prepend-icon="prependIcon"
        readonly
        v-bind="attrs"
        v-on="on"
      >
        <template #append v-if="$scopedSlots.append">
          <slot name="append" />
        </template>
      </v-text-field>
    </template>
    <v-time-picker
      v-model="time"
      format="24hr"
      @change="save"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
    name: 'zoezi-time-field',

    props: ['value', 'label', 'prependIcon'],

    data: () => ({
      time: null,
      menu: false,
    }),
    watch: {
      value() {
        this.time = this.value;
      }
    },
    methods: {
      save (time) {
        this.$emit('input', time);
        this.menu = false;
      }
    }
  }
</script>